import { render, staticRenderFns } from "./Components.vue?vue&type=template&id=2ef38f8e&scoped=true"
import script from "./Components.vue?vue&type=script&lang=js"
export * from "./Components.vue?vue&type=script&lang=js"
import style0 from "./Components.vue?vue&type=style&index=0&id=2ef38f8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef38f8e",
  null
  
)

export default component.exports